























































import axios, { AxiosResponse } from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { General } from '@/services/General';
import CommunicationWidgetDto from "@/services/CommunicationWidgetDto";
import { saveAs } from 'file-saver';





@Component
export default class CommunicationShow extends Vue {
    
   
    
    
    @Prop()
    communicationSelected:CommunicationWidgetDto;
    
    COMM_MODAL_ID = "communication-detail-modal";
    loading: boolean = false;
    

    

    async downloadAttachmentById(attachment){
        let url: string;
        if (attachment.sessionId) {
            url =  General.GetApiUrl("/api/document/DownloadDocumentGenericByIdSession?idSession="+attachment.sessionId);

        }else{
            url = General.GetApiUrl("/api/communication/DownloadAttachment?id="+attachment.id);
        }
         try {
            let response = await axios({
                method: 'get',
                url: url,
                withCredentials: true,
                responseType: 'blob'
            });
            saveAs(new Blob([response.data]), attachment.name);
        } catch (error) {
            General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);                               
        }
    }
    
    async mounted(){
    
        

        
    }
    
}
